/* Uses Nominatum API to geocode name of places and return a latitude and longitude*/

import { REACT_APP_BACKEND_URL } from "../constants";

async function getCoordinates(place: string): Promise<{ lat: number; lon: number }> {
  const response = await fetch(`${REACT_APP_BACKEND_URL}/geocode/${encodeURIComponent(place)}`, {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
    },
  });
  const data = await response.json();

  if (data && data?.data) {
    return {
      lat: parseFloat(data.data.latitude),
      lon: parseFloat(data.data.longitude),
    };
  } else {
    throw new Error("Coordinates not found");
  }

}

export default getCoordinates;